export default __webpack_public_path__ + "static/media/01d13.b83be5f6.jpg";